export const getUserFirstname = (state) => state.entities.users.currentUser?.firstName;
